<div>
    <form (ngSubmit)="save()" [formGroup]="form" novalidate class="flex flex-column">

        <div class="grid">
            <div class="col">

                <!-- Recherche Google Places -->
                <div class="flex align-items-center">
                    <div class="col-12 pl-1">
                        <div #placesContainer class="w-full"></div>
                    </div>
                </div>

                <!-- Champs pour personne physique -->
                @if (!isOrganization) {

                <!-- Civilité -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label for="civility">Civilité</label>
                    </div>
                    <div class="col-8">
                        <p-select [options]="civilities" formControlName="civility" appendTo="body" dataKey="code"
                            [showClear]="true" placeholder="Civilité">
                            <ng-template let-civility pTemplate="selectedItem">
                                @if (!!civility) {
                                <span>{{civility.label}}</span>
                                }
                            </ng-template>
                            <ng-template let-civility pTemplate="item">
                                <span>{{civility.label}}</span>
                            </ng-template>
                        </p-select>
                    </div>
                </div>
                <!-- Nom et prénom -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Nom et prénom <span class="text-red-500">*</span></label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="lastName" placeholder="Nom" required />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="firstName" placeholder="Prénom" required />
                    </div>
                </div>

                <!-- Deuxième personne -->

                <!-- Civilité -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label for="civility">Et</label>
                    </div>
                    <div class="col-8">
                        <p-select [options]="civilities" formControlName="secondCivility" appendTo="body" dataKey="code"
                            placeholder="Civilité" [showClear]="true">
                            <ng-template let-civility pTemplate="selectedItem">
                                @if (!!civility) {
                                <span>{{civility.label}}</span>
                                }
                            </ng-template>
                            <ng-template let-civility pTemplate="item">
                                <span>{{civility.label}}</span>
                            </ng-template>
                        </p-select>
                    </div>
                </div>
                <!-- Nom et prénom -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Nom et prénom</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="secondLastName" placeholder="Nom" />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="secondFirstName" placeholder="Prénom" />
                    </div>
                </div>

                } @else {
                <!-- Champs pour organisation -->

                <!-- Société -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Société <span class="text-red-500">*</span> / Service</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="company" placeholder="Société" />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="service" placeholder="Service" />
                    </div>
                </div>

                }

                <!-- Champs communs -->

                <!-- Rue 1 -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label for="street1">Rue @if (isOrganization) {<span class="text-red-500">*</span>}</label>
                    </div>
                    <div class="col-8">
                        <input type="text" pInputText formControlName="street1" placeholder="Rue" />
                    </div>
                </div>

                <!-- Rue 2 -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label for="street2">Complément</label>
                    </div>
                    <div class="col-8">
                        <input type="text" pInputText formControlName="street2" placeholder="Complément" />
                    </div>
                </div>

                <!-- Bâtiment / Appartement -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Bâtiment / Appartement</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="building" placeholder="Bâtiment" />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="appartment" placeholder="Appartement" />
                    </div>
                </div>

                <!-- Code postal / Ville -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Code postal @if (isOrganization) {<span class="text-red-500">*</span>} / Ville @if (isOrganization) {<span class="text-red-500">*</span>}</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="zipCode" placeholder="Code postal" />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="cityName" placeholder="Ville" />
                    </div>
                </div>

                <!-- Région / Pays -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Région / Pays @if (isOrganization) {<span class="text-red-500">*</span>}</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="stateProvince" placeholder="Région / État" />
                    </div>
                    <div class="col-4">
                        <app-country-select formControlName="country" [showClear]="true"></app-country-select>
                    </div>
                </div>

                @if (isOrganization) {

                <!-- Libellé CEDEX -->
                <div class="flex align-items-center">
                    <div class="col-4">
                        <label>Libellé / Code CEDEX</label>
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="cedexLabel" placeholder="Libellé CEDEX" />
                    </div>
                    <div class="col-4">
                        <input type="text" pInputText formControlName="cedexCode" placeholder="Code CEDEX" />
                    </div>
                </div>

                }

                @if (!hideSave) {
                <div class="col-12 flex justify-content-end">
                    @if (showCancel) {
                    <p-button type="button" label="Annuler" severity="secondary" class="mr-2" [rounded]="true"
                        [outlined]="true" (click)="onClickCancel()"></p-button>
                    }
                    <p-button type="submit" label="Sauvegarder" [rounded]="true" [disabled]="!canSave()"
                        [loading]="loading"></p-button>
                </div>
                }
            </div>
        </div>
    </form>
</div>
